import { FormElementField, useFormField } from 'components/FormElements';
import {
  ADDRESS_FIELD,
  ADDRESS_FIELDS,
  POSTAL_CODE_FIELD,
} from 'components/FormElements/constants';
import { GoogleAutocompleteAddress } from 'components/GoogleAutocomplete';
import { useSelectPlanCheckoutContext } from 'contexts/SelectPlanCheckoutContextProvider';
import { getPostalCodeErrorMessage } from 'lib/fieldValidation';

export const AddressInput = ({
  addressDetails = {},
  errors = {},
  fieldName,
  setAddressDetails,
  setErrors,
  ...inputProps
}) => {
  const { setBillingErrorMessage } = useSelectPlanCheckoutContext();

  const { [fieldName]: errorMessage } = errors;
  const { [fieldName]: fieldValue } = addressDetails;

  const setFieldValue = (value) => {
    setBillingErrorMessage && setBillingErrorMessage('');
    setAddressDetails &&
      setAddressDetails({ ...addressDetails, [fieldName]: value });
  };
  const zipCodeValidation = (value) =>
    getPostalCodeErrorMessage(value, addressDetails.country);

  const { handleOnBlur, handleOnChange } = useFormField({
    customFieldValidation:
      fieldName === POSTAL_CODE_FIELD ? zipCodeValidation : null,
    errors,
    isSelect: !!inputProps?.selectList,
    fieldName,
    setErrors,
    setFieldValue: inputProps?.setFieldValue || setFieldValue,
    trackingEventName: 'billingAddress',
    trackingEventType: 'selectPlanCheckout',
  });

  const fieldProps = {
    error: errorMessage,
    id: `billing-address-${fieldName}-input`,
    onBlur: handleOnBlur,
    onChange: handleOnChange,
    ...inputProps,
    ...ADDRESS_FIELDS[fieldName],
  };

  return fieldName === ADDRESS_FIELD ? (
    <GoogleAutocompleteAddress
      addressFields={addressDetails}
      resetErrors={() => setErrors && setErrors({})}
      setAddressFields={setAddressDetails}
      {...fieldProps}
    />
  ) : (
    <FormElementField value={fieldValue} {...fieldProps} />
  );
};
